function RosterUpload() {

}

RosterUpload.validExtension = [".csv", ".xlsx"]
RosterUpload.isXLSX = false;
RosterUpload.errors = [];

RosterUpload.events = {
    isInit: true,

    init: function() {
        var self = this;

        if (self.isInit) {
            $("#richardson-team-roster").on("click", ".upload-roster-button", self.onShowRosterUploadTab);
            $("#richardson-team-roster").on("click", ".roster-upload-submit", self.onSubmitCSVFile);
            $("#richardson-team-roster").on("click", ".cancel-upload", self.onCancelUpload);
            $("#richardson-team-roster").on("click", ".view-roster", self.onViewRoster);
            
            self.isInit = false;
        }
    },

    onShowRosterUploadTab: function() {
        RosterUpload.render();
    },

    onSubmitCSVFile: function() {
        // RosterUpload.parseCSV()
        var inputElement = document.querySelector("#richardson-team-roster .roster-csv-file");
        var files = inputElement.value;
        var fileExtension = RosterUpload.getFileExtension(files);

        // Empty Errors
        RosterUpload.errors = [];

        if (_.size(files) > 0) {
            if (_.contains(RosterUpload.validExtension, fileExtension)) {
                var message = "Your current roster will be overwritten. Do you wish to continue?";
                
                if (RosterPanel.checkTeamRosterContent()) {
                    UIkit.modal.confirm(message, {stack: true}).then(function() {
                        RosterUpload.events.processFile(fileExtension, inputElement);
                    });
                } else {
                    RosterUpload.events.processFile(fileExtension, inputElement);
                }
            } else {
                RosterUpload.showErrorMessage("Invalid file format. Please use csv or xlsx file.");
            }
        } else {
            RosterUpload.showErrorMessage("Please select file.");
        }
    },

    processFile: function(fileExtension, inputElement) {
        if (fileExtension === ".csv") {
            RosterUpload.parseCSV();
        } else if (fileExtension === ".xlsx") {
            $("#richardson-team-roster .loading-bar").removeClass("uk-hidden");
            $("#richardson-team-roster .roster-upload-submit").addClass("uk-disabled");

            RosterUpload.readXLSX(inputElement.files[0]);
        } else {
            RosterUpload.showErrorMessage("Invalid file format. Please use csv or xlsx file.");
        }
    },

    onCancelUpload: function() {
        RosterUpload.render();
    },

    onViewRoster: function() {
        $("#richardson-team-roster .roster-player-list-table").html("");

        RosterPanel.events.prepareUniformSizes();
        RosterPanel.events.preparePlayerNumbers();
        RosterPanel.events.prepareRosterSummary();
        RosterPanel.events.onHoverPlayerNumberActive();

        // Post Complete
        $("#richardson-team-roster .loading-bar").addClass("uk-hidden");
        $("#richardson-team-roster .roster-upload-submit").removeClass("uk-disabled");

        UIkit.switcher(".roster-menu").show(0);
    }
}

RosterUpload.render = function() {
    var template = _.template(document.getElementById("upload-csv-form").innerHTML);
    var rosterTemplate;
    
    if (ub.funcs.isSocks()) {
        rosterTemplate = "https://docs.google.com/spreadsheets/d/1f9f9CzFau9-HqKYh-75xbXGKkYUDYaK2aoWNzIjrdso/export?format=xlsx";
    } else if (ub.funcs.isBaseBall() && ub.funcs.isLower()) {
        rosterTemplate = "https://docs.google.com/spreadsheets/d/18xxFscPvFPkpsEU8O_SZK8PawV0PhmnEYzzQcq7eHfQ/export?format=xlsx";
    } else {
        rosterTemplate = "https://docs.google.com/spreadsheets/d/1yhZh6EafBKdZw0bak4gk5KglDkw4xQU-r9VrbymlMhc/export?format=xlsx";
    }

    $("#richardson-team-roster .upload-csv-container").html("");
    $("#richardson-team-roster .upload-csv-container").html(template({
        rosterTemplate: rosterTemplate
    }));
}

RosterUpload.renderError = function(errors) {
    var template = _.template(document.getElementById("upload-render-errors").innerHTML);
    $("#richardson-team-roster .upload-content").html("");
    $("#richardson-team-roster .upload-content").html(template({
        errors: errors
    }));
}

RosterUpload.parseCSV = function() {
    var firstError, errorCount;
    
    $('.roster-csv-file').parse({
        config: RosterUpload.config(),
        before: function(file, inputElem) {
            $("#richardson-team-roster .roster-upload-submit").addClass("uk-disabled");
            $("#richardson-team-roster .loading-bar").removeClass("uk-hidden");
        },
        error: function(err, file) {
            console.log("ERROR:", err, file);
            firstError = firstError || err;
            errorCount++;

            ub.utilities.notifyMe(firstError, "danger");
        },
        complete: RosterUpload.onComplete
    });
}

RosterUpload.error = function(err, file) {
    ub.utilities.notifyMe("Something went wrong while parsing file.", "danger");
}

RosterUpload.success = function(results) {
    if (results && results.errors) {
		if (results.errors) {
			errorCount = results.errors.length;
			firstError = results.errors[0];
		}

		if (results.data && results.data.length > 0) {
            rowCount = results.data.length;
        }
	}

    // Header Checker
    var headers = results.meta.fields;
    RosterUpload.headerChecker(headers, function() {
        if (RosterUpload.isXLSX) {
            RosterUpload.loadXLSXData(results);
            RosterUpload.isXLSX = false;
        } else {
            RosterUpload.loadCSVData(results);
        }
    });
}

RosterUpload.loadXLSXData = function(parseData) {
    if (_.size(parseData.errors) > 0) {
        ub.utilities.notifyMe("Something went wrong while parsing file.", "danger");
        return;
    }

    RosterUpload.loadCSVData(parseData, function() {
        RosterUpload.onComplete()
    })
}

RosterUpload.loadCSVData = function(results, callback) {
    if (typeof results !== "undefined") {
        RosterPanel.teamRoster = [];
        var rosterList = results.data;

        if (_.size(rosterList) > 0) {
            _.each(rosterList, function(roster_item) {
                var tagid = roster_item["TAG ID"];
                var size = roster_item["SIZE"];
                var last_name = roster_item["NAME"];
                var number = roster_item["NUMBER"];
                var qty = roster_item["QUANTITY"];
                var inseam = roster_item["INSEAM"]

                if (typeof last_name === "undefined" || last_name === null) {
                    last_name = roster_item["LAST NAME"];
                }

                if (typeof qty === "undefined" || qty === null) {
                    qty = roster_item["QTY"];
                }

                var sizeOrder = RosterPanel.sizeOrder.findOrder(size);
                var sizeCategory = RosterPanel.findSizeCategory(size);
                var category;
                
                if (typeof size !== "undefined" && size !== null) {
                    if (typeof sizeCategory !== "undefined") {
                        if (ub.funcs.isSocks()) {
                            category = ""
                        } else {
                            category = sizeCategory.category;
                        }
    
                        var find = _.find(RosterPanel.teamRoster, {size: size, category: category});
                        var rosterContent = RosterUpload.rosterListContent(tagid, size, last_name, number, qty, category);
    
                        if (typeof find !== "undefined") {
                            find.rosters.push(rosterContent);
                        } else {
                            var newRosterArr = [];
                            newRosterArr.push(rosterContent);
    
                            RosterPanel.teamRoster.push({
                                rosters: newRosterArr,
                                category: category,
                                size: size,
                                order: typeof sizeOrder !== "undefined" ? sizeOrder.order : 0
                            })
                        }
                    } else {
                        RosterUpload.errors.push("Size " + size + " is not available in this uniform");
                    }
                }
            });
        }

        if (_.isFunction(callback)) {
            callback();
        }
    }
}

RosterUpload.readXLSX = function(file) {
    var url = URL.createObjectURL(file);

    var oReq = new XMLHttpRequest();
    oReq.open("GET", url, true);
    oReq.responseType = "arraybuffer";

    oReq.onload = function(e) {
        var arraybuffer = oReq.response;

        var data = new Uint8Array(arraybuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");

        var workbook = XLSX.read(bstr, {
            type: "binary"
        });


        var first_sheet_name = workbook.SheetNames[0];
        
        var worksheet = workbook.Sheets[first_sheet_name];
        var rosterCSV = XLSX.utils.sheet_to_csv(worksheet);

        var parseConfig = RosterUpload.config();
        RosterUpload.isXLSX = true;
        var parseCSV = Papa.parse(rosterCSV, parseConfig);
    }

    oReq.send();
}

RosterUpload.config = function() {
    return {
		delimiter:"",
		header: true,
		dynamicTyping: true,
		skipEmptyLines: true,
		preview: 0,
		step: undefined,
		encoding: "",
		worker: true,
		comments: "RICHARDSON ROSTER",
		complete: RosterUpload.success,
		error: RosterUpload.error,
		download: false
	};
}

RosterUpload.getFileExtension = function(fileName) {
    var extension = fileName.substring(fileName.lastIndexOf('.'));
    return extension;
}

RosterUpload.showErrorMessage = function(message) {
    $("#richardson-team-roster .error-message").removeClass("uk-hidden");

    $("#richardson-team-roster .error-message p").html("")
    $("#richardson-team-roster .error-message p").html(message);

    if (!$("#richardson-team-roster .error-message").hasClass("uk-hidden")) {
        _.delay(function() {
            $("#richardson-team-roster .error-message").addClass("uk-hidden")
        }, 5000)
    }
}

RosterUpload.onComplete = function() {
    if (_.size(RosterUpload.errors) > 0) {
        RosterUpload.renderError(RosterUpload.errors);
    } else {
        ub.utilities.notifyMe("File successfully uploaded.", "success");

        $("#richardson-team-roster .roster-player-list-table").html("");

        RosterPanel.events.prepareUniformSizes();
        RosterPanel.events.preparePlayerNumbers();
        RosterPanel.events.prepareRosterSummary();
        RosterPanel.events.onHoverPlayerNumberActive();

        // Post Complete
        $("#richardson-team-roster .loading-bar").addClass("uk-hidden");
        $("#richardson-team-roster .roster-upload-submit").removeClass("uk-disabled");

        UIkit.switcher(".roster-menu").show(0);
    }
}

RosterUpload.rosterListContent = function(tag_id, size, last_name, number, qty, category) {
    var content;

    if (ub.funcs.isSocks()) {
        content = {
            size: typeof size !== "undefined" && size !== null ? size : "",
            number: "",
            qty: typeof qty !== "undefined" && qty !== null ? qty : 1,
            lastName: "",
            category: category,
            inseam: "",
            tagid: ""
        }
    } else {
        content = {
            size: typeof size !== "undefined" && size !== null ? size : "",
            number: typeof number !== "undefined" && number !== null ? number.toString() : "",
            qty: typeof qty !== "undefined" && qty !== null ? qty : 1,
            lastName: typeof last_name !== "undefined" && last_name !== null ? last_name : "",
            category: category,
            inseam: ub.funcs.isBaseBall() && ub.funcs.is_lower() ? "standard" : "",
            tagid: typeof tag_id !== "undefined" && tag_id !== null ? tag_id : ""
        }
    }

    return content;
}

RosterUpload.headerChecker = function(headers, callback) {
    if (!_.contains(headers, "SIZE")) {
        RosterUpload.errors.push("Header column SIZE is missing, please check format.")
    }

    if (!_.contains(headers, "QUANTITY") && !_.contains(headers, "QTY")) {
        RosterUpload.errors.push("Header column QUANTITY is missing, please check format.")
    }

    if (!ub.funcs.isSocks()) {
        if (!_.contains(headers, "NAME") && !_.contains(headers, "LAST NAME")) {
            RosterUpload.errors.push("Header column LAST NAME is missing, please check format.")
        }
    
        if (!_.contains(headers, "NUMBER")) {
            RosterUpload.errors.push("Header column NUMBER is missing, please check format.")
        }

        if (!_.contains(headers, "TAG ID")) {
            RosterUpload.errors.push("Header column TAG is missing, please check format.")
        }
    }

    if (_.isFunction(callback)) {
        callback()
    }
}